<template>
    <v-container fluid>
        
        <img class="text-center login-logo" width="200" alt="Master Meal Planner logo" src="@/assets/logo.png" @click="goToPath('/')">
        <h1 class="mmp-title">Master Meal Planner</h1>
        <v-layout row wrap>

            <h1>{{ msg }}</h1>
            <v-flex xs12 sm6 md6 lg6 class="mrgauto">
                <v-card>
                    <v-toolbar color="light-blue lighten-4" light>
                        <v-toolbar-title>{{title}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!-- Singup form -->
                        <v-form ref="form">
                            <v-text-field v-model="userInfoModel.userName" :type="'text'" :rules="userRules.userName" label="Username" required @input="validateSingupForm"></v-text-field>
                            <v-text-field v-model="userInfoModel.email" :type="'email'" :rules="userRules.email" label="E-mail" required @input="validateSingupForm"></v-text-field>
                            <v-text-field v-model="userInfoModel.password" :type="'password'" :rules="userRules.password" label="Password" required @input="validateSingupForm"></v-text-field>
                            <v-text-field v-model="userInfoModel.confirmPassword" :type="'password'" :rules="userRules.confirmPassword" label="Confirm Password" required @input="validateSingupForm"></v-text-field>
                            <v-select
                                :items="subscriptionPlans"
                                v-model="userInfoModel.subscriptionPlan"
                                label="Subscription plan"
                                single-line
                                @change="onSubscriptionChange"
                            ></v-select>

                            <card class='stripe-card'
                            :class='{ completeCard }'
                            :stripe='stripeKey'
                            :options='stripeOptions'
                            @change='completeCard = $event.complete'
                            v-if="userInfoModel.subscriptionPlan != 'basic'"
                            />
                            
                            <v-checkbox v-model="userInfoModel.isAgree" label="I agree with Terms and conditions" required @change="validateSingupForm"></v-checkbox>
                            <v-btn :disabled='!isValidSingupForm || isSingup' depressed color="success" @click="singup" class="pay-btn">{{payBtn}}</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Utils from '@/services/Utils.js';
    import CONSTANT from '@/services/Constant.js';
    import UserService from '@/services/db/UserService.js';
    import stripeMixin from '@/services/stripeMixin.js';
    import axios from "axios";
    import { Card, CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus';
    
    export default {
        name: "Singup",
        components: { Card, CardNumber, CardExpiry, CardCvc },
        props: {
            msg: String
        },
        created() {
            
        },
        data: () => ({
            title: 'Create account',
            subscriptionPlans: CONSTANT.LIST.SUBSCRIPTION_PLANS,
            payBtn: 'Create account',
            stripeOptions: {
            },
            showPaymentModal: false,
            stripeKey: CONSTANT.STRIPE_PK_KEY,
            completeCard: false,
            userInfoModel: {
                email: 'm1@mmp.com',
                userName: 'member',
                subscriptionPlan: 'basic',
                isAgree: false,
                password: 'test123',
                confirmPassword: 'test123',
            },
            valid: true,
            userRules: {
                userName: [
                    v => !!v || 'Username is required'
                ],
                email: [
                    v => !!v || 'E-mail is required',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],
                isAgree: [
                    v => !!v || 'You must agree with terms and conditions',
                ],
                subscriptionPlan: [
                    v => !!v || 'Select subscription plan',
                ],
                password: [
                    v => !!v || 'Password is required',
                    v => (v && v.length >= 8) || 'Password must be atleast 8 characters'
                ]
            },
            isValidSingupForm : false,
            isSingup : false
        }),
        methods: {
            /*
            * Method to validate singup form
            */
            validateSingupForm() {
                if (!this.userInfoModel || (!Utils.isValidEmail(this.userInfoModel.email) || this.userInfoModel.password.length < 8) || this.userInfoModel.password != this.userInfoModel.confirmPassword || this.userInfoModel.isAgree == false
                ) {
                    this.isValidSingupForm = false;
                } else {
                    this.isValidSingupForm = true;
                }
            },

            /*
            * Called when subscription plan changed
            */
            onSubscriptionChange(){
                var _plan = this.userInfoModel.subscriptionPlan;
                this.payBtn = (_plan == 'basic')? 'Create account' : ((_plan == 'weekly')? 'PAY $9.99' : ((_plan == 'yearly')? 'PAY $249.99' : 'PAY $49.99'));
            },

            /*
            * Method to singup user
            */
            singup () {
                if (this.isValidSingupForm) {
                    UserService.getUserByEmail(this.userInfoModel.email)
                    .then(res => {
                        if (res == 0) {
                            this.isSingup = true;
                            this.pay((isSuccess, res) => {
                                if(!isSuccess){
                                    this.isSingup = false;
                                } else {
                                    UserService.createUserWithEmailAndPassword(this.userInfoModel).then((user) => {
                                        if(user.code){
                                            this.$store.commit('setAlert', {isAlertError: true, message: user.message});
                                            this.isSingup = false;
                                        } else {
                                            var _USER = user.user;
                                            this.addUser(this.userInfoModel, _USER, (addError, addUserSuccess) => {
                                                this.isSingup = false;
                                                if(addError){
                                                    this.$store.commit('setAlert', {isAlertError: true, message: addError});
                                                } else {
                                                    this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.USER.SINGUP_SUCCESS});
                                                    location.href = '/login';
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        } else {
                            this.$store.commit("setAlert", {
                                isAlertError: true,
                                message: CONSTANT.MESSAGES.USER.EMAIL_ALREADY_EXISTS
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: CONSTANT.MESSAGES.USER.FAIL_GET_USER_PROFILE
                        });
                    })
                }
            },
            
            /*
            * Method to do payment for pro user
            */
            pay (callback) {
                if(this.userInfoModel.subscriptionPlan === 'basic'){
                    callback(true, {});
                } else {
                    if(this.completeCard){
                        createToken().then(data => {
                            stripeMixin.stripeResponseHandler(data.token, (isSuccess, res) => {
                                callback(isSuccess, res);
                            });
                        })
                    } else {
                        this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.SUBSCRIPTION.CARD_DETAILS_MISSING});
                        callback(false, {});
                    }
                }
            },

            /*
            * Method to add new user
            */
            addUser(getUser, _USER, callback){
                var _user = {
                    email: _USER.email,
                    referCode: "",
                    referenceCode: "",
                    registrationDate: "",
                    showTutorial: true,
                    subscription: getUser.subscriptionPlan,
                    role: (getUser.subscriptionPlan === 'basic')? "basic" : "pro",
                    userCurrentEmail: getUser.email,
                    userId: _USER.uid
                };

                UserService.addNewUser(_user, _USER.uid)
                .then(() => {
                    callback(null, _user);
                })
                .catch((error) => {
                    callback(error, null);
                });
            },


            /*
            * Method to go to specified path
            */
            goToPath(path) {
                this.$router.push(path);
            }             
        }
    };
</script>
<style scoped>
    .login-logo {
        margin: 10px auto 10px auto;
        display: block;
    }
    .mmp-title {
        text-align:center;
        font-size:48px;
        font-weight:bold;
        margin-bottom:10px;
    }    
    .pay-btn{
        width: 95%;
        padding: 20px 20px;
        height: 65px;
        background-color: #FFAC00 !important;
    }
</style>